document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".game-header__promo-banner").forEach((banner) => {
    const hash = banner.dataset.hash;
    const hashHide = banner.dataset.hashHide;
    if (hash && window.location.hash.replace("#", "").includes(hash) == false) {
      banner.classList.add("game-header__promo-banner--hidden");
    }
    if (hashHide && window.location.hash.replace("#", "").includes(hashHide)) {
      banner.classList.add("game-header__promo-banner--hidden");
    }
  });

  /* ALL SECTIONS */
  document.querySelectorAll(".section").forEach((section) => {
    section.querySelectorAll(".section__floating-image").forEach((image) => {
      if (typeof gsap !== "undefined") {
        const timeline = gsap.timeline();
        console.log(image);
      }
    });
  });

  /* SECTION POLAROID REVEAL */
  if (typeof gsap !== "undefined") {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 700px)", () => {
      document
        .querySelectorAll(".shopify-section--polaroid-reveal")
        .forEach((section) => {
          section.querySelectorAll(".polaroid-reveal__item").forEach((item) => {
            const timeline = gsap.timeline();

            timeline.add("start");

            timeline.to(
              item.querySelector(".polaroid-reveal__item-polaroid--left"),
              {
                x: -400,
                rotation: -4,
                duration: 1,
                ease: "power2.out",
              },
              "start"
            );

            timeline.to(
              item.querySelector(".polaroid-reveal__item-polaroid--right"),
              {
                x: 400,
                rotation: 4,
                duration: 1,
                ease: "power2.out",
              },
              "start"
            );

            ScrollTrigger.create({
              trigger: item,
              animation: timeline,
              start: "top bottom",
              end: "top top",
              scrub: true,
            });
          });
        });
    });
  }

  /* SECTION STORY SLIDER */
  document
    .querySelectorAll(".shopify-section--story-slider")
    .forEach((section) => {
      const swiperContainer = section.querySelector(".swiper");
      if (swiperContainer) {
        new Swiper(swiperContainer, {
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          spaceBetween: 16,
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: section.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            1080: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        });
      }
    });

  /* SECTION AMAZON TESTIMONIALS */
  document
    .querySelectorAll(".shopify-section--amazon-testimonials")
    .forEach((section) => {
      const swiperContainer = section.querySelector(".swiper");
      if (swiperContainer) {
        new Swiper(swiperContainer, {
          slidesPerView: 1.2,
          spaceBetween: 20,
          loop: true,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
          },
          breakpoints: {
            640: {
              slidesPerView: 4,
            },
          },
        });
      }
    });

  /* SECTION FEATURED PRODUCT WITH BOX */
  document
    .querySelectorAll(".shopify-section--featured-product-with-box")
    .forEach((section) => {
      if (typeof gsap !== "undefined") {
        let mm = gsap.matchMedia();

        mm.add("(min-width: 640px)", () => {
          const timeline = gsap.timeline();

          timeline.fromTo(
            section.querySelector(".featured-product-with-box__box"),
            {
              y: 156,
              rotation: 25,
            },
            {
              y: 0,
              rotation: 15,
              duration: 1,
            }
          );

          ScrollTrigger.create({
            trigger: section,
            animation: timeline,
            start: "top bottom",
            end: "top top",
            scrub: true,
          });
        });
      }
    });

  /* SECTION EDITO BOX WITH CARDS */
  document
    .querySelectorAll(".shopify-section--edito-box-with-cards")
    .forEach((section) => {
      if (typeof gsap !== "undefined") {
        let mm = gsap.matchMedia();

        mm.add("(min-width: 640px)", () => {
          const timeline = gsap.timeline();

          timeline.fromTo(
            section.querySelector(".section__background-image"),
            {
              y: 0,
            },
            {
              y: 360,
              duration: 1,
              ease: "none",
            },
            0
          );

          timeline.fromTo(
            section.querySelectorAll(".edito-box-with-cards__card--index-3"),
            {
              y: 56,
            },
            {
              y: 256,
              duration: 1,
              ease: "none",
            },
            0
          );

          timeline.fromTo(
            section.querySelectorAll(".edito-box-with-cards__card--index-2"),
            {
              y: 32,
            },
            {
              y: 156,
              duration: 1,
              ease: "none",
            },
            0
          );

          timeline.fromTo(
            section.querySelectorAll(".edito-box-with-cards__card--index-1"),
            {
              y: 0,
            },
            {
              y: 96,
              duration: 1,
              ease: "none",
            },
            0
          );

          timeline.fromTo(
            section.querySelector(".edito-box-with-cards__box"),
            {
              y: 0,
            },
            {
              y: 32,
              duration: 1,
              ease: "none",
            },
            0
          );

          ScrollTrigger.create({
            trigger: section,
            animation: timeline,
            start: "top top",
            end: "bottom top",
            scrub: true,
          });
        });
      }
    });
});
